import {useEffect, useState} from 'react';
import './scss/App.scss';
import House from './components/house';
import HouseMobile from './components/housemobile';
import HouseNoAnimate from './components/houseNoAnimate';
import Hero from './sections/hero';
import FindAPLace from './sections/findaplace';
import ComeExperience from './sections/comeexperience';
import Inspiring from './sections/inspiring';
import MakeItYours from './sections/makeityours';
import NittyGritty from './sections/nittygritty';
import Commitment from './sections/commitment';
import LegalBit from './sections/legalbit';
import JourneyEnd from './sections/journeyend';
import ComeToLife from './sections/cometolife';
import MediaQuery from 'react-responsive';


function App() {

  const [animate, setAnimate] = useState(localStorage.getItem('animate') == 'false' ? false : true);
  
  function handleToggle () {
    setAnimate(!animate);
  }

  useEffect(() => {
    localStorage.setItem('animate', animate);
  } ,[animate]); 

  return (
    <div className="App mx-auto" data-scoped>
      <div className="toggle-container">
        <button className={`anim-toggle ${animate ? "on" : "off"}`} onClick={() => handleToggle()}>Turn animation {animate ? "off" : "on"}</button>
      </div>
      <Hero animate={animate}/>
      <FindAPLace animate={animate}/>
      <ComeExperience animate={animate}/>
      <Inspiring animate={animate}/>
      <MakeItYours animate={animate}/>
      <NittyGritty animate={animate}/>
      <Commitment animate={animate}/>
      <LegalBit animate={animate}/>
      <ComeToLife animate={animate}/>
      { animate &&
        <>
          <MediaQuery maxWidth={767}>
            <HouseMobile/>
          </MediaQuery>
          <MediaQuery minWidth={768}>
            <House/>
          </MediaQuery> 
        </> 
      }
      { !animate &&
        <HouseNoAnimate/>
      }
      <JourneyEnd animate={animate}/>
    </div>
  );
}

export default App;